import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerYPositionListItem = (props) => {
    const { visualizerPositionY, updateVisualizerSettings, maxYPosition } = props;
    
    const onPositionChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ position: { y: value } });
    };
    
    return (
        <SliderListItem
            title='Y Position'
            value={visualizerPositionY}
            displayMultiplier={-1}
            min={-maxYPosition}
            max={maxYPosition}
            step={1}
            onValueChange={onPositionChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { y: visualizerPositionY } = state.createPreview.present.videoSettings.visualizer.position;
    const { maxYPosition } = state.create.maxValues;

    return { 
        visualizerPositionY,
        maxYPosition
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerYPositionListItem);